import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../../assets/kefu.png';
var _hoisted_1 = {
  class: "header-actions"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "header-main"
};
var _hoisted_4 = {
  class: "cta-wrap"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "content"
};
var _hoisted_7 = {
  class: "grid"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "cover"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  class: "play-icon"
};
var _hoisted_12 = {
  class: "title"
};
var _hoisted_13 = {
  class: "meta"
};
var _hoisted_14 = {
  class: "user"
};
var _hoisted_15 = {
  class: "avatar"
};
var _hoisted_16 = ["src"];
var _hoisted_17 = {
  key: 1,
  class: "avatar-fallback"
};
var _hoisted_18 = {
  class: "name"
};
var _hoisted_19 = {
  class: "stats"
};
var _hoisted_20 = {
  class: "count"
};
var _hoisted_21 = {
  class: "content"
};
var _hoisted_22 = {
  class: "grid"
};
var _hoisted_23 = ["onClick"];
var _hoisted_24 = {
  class: "cover"
};
var _hoisted_25 = ["src"];
var _hoisted_26 = {
  class: "play-icon"
};
var _hoisted_27 = {
  class: "title"
};
var _hoisted_28 = {
  class: "meta"
};
var _hoisted_29 = {
  class: "user"
};
var _hoisted_30 = {
  class: "avatar"
};
var _hoisted_31 = ["src"];
var _hoisted_32 = {
  key: 1,
  class: "avatar-fallback"
};
var _hoisted_33 = {
  class: "name"
};
var _hoisted_34 = {
  class: "stats"
};
var _hoisted_35 = {
  class: "count"
};
var _hoisted_36 = {
  class: "player"
};
var _hoisted_37 = ["src"];
var _hoisted_38 = {
  class: "publish-sheet"
};
var _hoisted_39 = {
  class: "publish-left"
};
var _hoisted_40 = {
  class: "publish-icon"
};
var _hoisted_41 = ["src"];
var _hoisted_42 = {
  class: "publish-left"
};
var _hoisted_43 = {
  class: "publish-icon"
};
var _hoisted_44 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_WechatOpenLaunchApp = _resolveComponent("WechatOpenLaunchApp");
  var _component_van_button = _resolveComponent("van-button");
  var _component_van_empty = _resolveComponent("van-empty");
  var _component_van_icon = _resolveComponent("van-icon");
  var _component_van_list = _resolveComponent("van-list");
  var _component_van_tab = _resolveComponent("van-tab");
  var _component_van_tabs = _resolveComponent("van-tabs");
  var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  var _component_van_popup = _resolveComponent("van-popup");
  var _component_CreatorContestKefuPopup = _resolveComponent("CreatorContestKefuPopup");
  var _component_CirclePostOpenAppConfirm = _resolveComponent("CirclePostOpenAppConfirm");
  return _openBlock(), _createElementBlock("div", {
    class: "creator-contest",
    style: _normalizeStyle($options.pageBgStyle)
  }, [_createElementVNode("div", {
    class: "top-bg",
    style: _normalizeStyle($options.topBgStyle)
  }, null, 4), _createElementVNode("div", {
    class: "header",
    style: _normalizeStyle($options.headerStyle)
  }, [_cache[20] || (_cache[20] = _createElementVNode("div", {
    class: "header-top"
  }, [_createElementVNode("div", {
    class: "spacer"
  })], -1)), _createElementVNode("div", _hoisted_1, [$options.showHeaderShareBtn ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onClickShare && $options.onClickShare.apply($options, arguments);
    })
  }, [_createElementVNode("img", {
    class: "share-icon",
    src: $data.shareIcon,
    alt: ""
  }, null, 8, _hoisted_2)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "kefu-btn",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.onKefuClick && $options.onKefuClick.apply($options, arguments);
    })
  }, _toConsumableArray(_cache[16] || (_cache[16] = [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1)]))), _createElementVNode("div", {
    class: "rule-btn",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.onRulesClick && $options.onRulesClick.apply($options, arguments);
    })
  }, "规则")]), _createElementVNode("div", _hoisted_3, [_cache[18] || (_cache[18] = _createElementVNode("div", {
    class: "headline"
  }, "【来起泡 发视频 赢10万现金大奖】", -1)), _cache[19] || (_cache[19] = _createElementVNode("div", {
    class: "subline"
  }, "首届泛文化视频共创大赛", -1)), _createElementVNode("div", _hoisted_4, [$options.shouldUseWechatLaunchTagForJoin ? (_openBlock(), _createBlock(_component_WechatOpenLaunchApp, {
    key: 0,
    class: "cta-wx-open",
    "app-id": _ctx.wechatOpenLaunchAppId,
    extinfo: $options.wxActivityLaunchExtinfo,
    "button-text": "我也要参赛",
    variant: "cta"
  }, null, 8, ["app-id", "extinfo"])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "cta",
    style: _normalizeStyle($options.ctaStyle),
    onClick: _cache[3] || (_cache[3] = function () {
      return $options.onJoinClick && $options.onJoinClick.apply($options, arguments);
    })
  }, [_cache[17] || (_cache[17] = _createElementVNode("div", {
    class: "cta-text"
  }, "我也要参赛", -1)), _createElementVNode("img", {
    class: "cta-icon",
    src: $data.htbgicon,
    alt: ""
  }, null, 8, _hoisted_5)], 4))])])], 4), _createVNode(_component_van_pull_refresh, {
    modelValue: $data.refreshing,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $data.refreshing = $event;
    }),
    onRefresh: $options.onRefresh
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_tabs, {
        active: $data.activeTab,
        "onUpdate:active": _cache[6] || (_cache[6] = function ($event) {
          return $data.activeTab = $event;
        }),
        class: "contest-tabs",
        swipeable: "",
        animated: "",
        color: '#b63a2f',
        "line-width": '22px',
        "line-height": '3px',
        "title-active-color": '#2d1e10',
        "title-inactive-color": '#8a7a69',
        onChange: $options.onTabChange
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_tab, {
            title: "最新",
            name: "latest"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_6, [!$data.latest.loading && !$data.refreshing && $data.latest.items.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
                key: 0,
                description: $data.latest.error ? '加载失败' : '暂无内容'
              }, {
                default: _withCtx(function () {
                  return [$data.latest.error ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 0,
                    size: "small",
                    type: "primary",
                    onClick: $options.onRetry
                  }, {
                    default: _withCtx(function () {
                      return _toConsumableArray(_cache[21] || (_cache[21] = [_createTextVNode(" 点击重试 ", -1)]));
                    }),
                    _: 1
                  }, 8, ["onClick"])) : _createCommentVNode("", true)];
                }),
                _: 1
              }, 8, ["description"])) : (_openBlock(), _createBlock(_component_van_list, {
                key: 1,
                loading: $data.latest.loading,
                "onUpdate:loading": _cache[4] || (_cache[4] = function ($event) {
                  return $data.latest.loading = $event;
                }),
                finished: $data.latest.finished,
                "finished-text": "没有更多了",
                onLoad: $options.onLoadLatest
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.latest.items, function (item) {
                    var _item$user_info, _item$like_count;
                    return _openBlock(), _createElementBlock("div", {
                      class: "card",
                      key: item.post_id,
                      onClick: function onClick($event) {
                        return $options.onPlay(item);
                      }
                    }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
                      class: "cover-img",
                      src: $options.getCoverUrl(item),
                      alt: ""
                    }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_icon, {
                      name: "play"
                    })])]), _createElementVNode("div", _hoisted_12, _toDisplayString(item.title || item.description || ' '), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [$options.getAvatarUrl(item) ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "avatar-img",
                      src: $options.getAvatarUrl(item),
                      alt: ""
                    }, null, 8, _hoisted_16)) : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($options.getUserInitial(item)), 1))]), _createElementVNode("div", _hoisted_18, _toDisplayString(((_item$user_info = item.user_info) === null || _item$user_info === void 0 ? void 0 : _item$user_info.user_name) || '用户'), 1)]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_van_icon, {
                      name: "like-o"
                    }), _createElementVNode("span", _hoisted_20, _toDisplayString((_item$like_count = item.like_count) !== null && _item$like_count !== void 0 ? _item$like_count : 0), 1)])])], 8, _hoisted_8);
                  }), 128))])];
                }),
                _: 1
              }, 8, ["loading", "finished", "onLoad"]))])];
            }),
            _: 1
          }), _createVNode(_component_van_tab, {
            title: "最热",
            name: "hot"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_21, [!$data.hot.loading && !$data.refreshing && $data.hot.items.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
                key: 0,
                description: $data.hot.error ? '加载失败' : '暂无内容'
              }, {
                default: _withCtx(function () {
                  return [$data.hot.error ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 0,
                    size: "small",
                    type: "primary",
                    onClick: $options.onRetry
                  }, {
                    default: _withCtx(function () {
                      return _toConsumableArray(_cache[22] || (_cache[22] = [_createTextVNode(" 点击重试 ", -1)]));
                    }),
                    _: 1
                  }, 8, ["onClick"])) : _createCommentVNode("", true)];
                }),
                _: 1
              }, 8, ["description"])) : (_openBlock(), _createBlock(_component_van_list, {
                key: 1,
                loading: $data.hot.loading,
                "onUpdate:loading": _cache[5] || (_cache[5] = function ($event) {
                  return $data.hot.loading = $event;
                }),
                finished: $data.hot.finished,
                "finished-text": "没有更多了",
                onLoad: $options.onLoadHot
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hot.items, function (item) {
                    var _item$user_info2, _item$like_count2;
                    return _openBlock(), _createElementBlock("div", {
                      class: "card",
                      key: item.post_id,
                      onClick: function onClick($event) {
                        return $options.onPlay(item);
                      }
                    }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
                      class: "cover-img",
                      src: $options.getCoverUrl(item),
                      alt: ""
                    }, null, 8, _hoisted_25), _createElementVNode("div", _hoisted_26, [_createVNode(_component_van_icon, {
                      name: "play"
                    })])]), _createElementVNode("div", _hoisted_27, _toDisplayString(item.title || item.description || ' '), 1), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [$options.getAvatarUrl(item) ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "avatar-img",
                      src: $options.getAvatarUrl(item),
                      alt: ""
                    }, null, 8, _hoisted_31)) : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($options.getUserInitial(item)), 1))]), _createElementVNode("div", _hoisted_33, _toDisplayString(((_item$user_info2 = item.user_info) === null || _item$user_info2 === void 0 ? void 0 : _item$user_info2.user_name) || '用户'), 1)]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_van_icon, {
                      name: "like-o"
                    }), _createElementVNode("span", _hoisted_35, _toDisplayString((_item$like_count2 = item.like_count) !== null && _item$like_count2 !== void 0 ? _item$like_count2 : 0), 1)])])], 8, _hoisted_23);
                  }), 128))])];
                }),
                _: 1
              }, 8, ["loading", "finished", "onLoad"]))])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["active", "onChange"])];
    }),
    _: 1
  }, 8, ["modelValue", "onRefresh"]), _createVNode(_component_van_popup, {
    show: $data.player.show,
    "onUpdate:show": _cache[9] || (_cache[9] = function ($event) {
      return $data.player.show = $event;
    }),
    position: "center",
    round: "",
    class: "player-popup"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", {
        class: "player-close",
        onClick: _cache[8] || (_cache[8] = function () {
          return $options.closePlayer && $options.closePlayer.apply($options, arguments);
        })
      }, [_createVNode(_component_van_icon, {
        name: "cross"
      })]), _createElementVNode("video", {
        ref: "videoEl",
        class: "player-video",
        src: $data.player.url,
        controls: "",
        autoplay: "",
        playsinline: "",
        "webkit-playsinline": "",
        "x5-playsinline": ""
      }, null, 8, _hoisted_37)])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.publishSheetShow,
    "onUpdate:show": _cache[13] || (_cache[13] = function ($event) {
      return $data.publishSheetShow = $event;
    }),
    position: "bottom",
    round: "",
    class: "publish-sheet-popup"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", {
        class: "publish-item",
        onClick: _cache[10] || (_cache[10] = function ($event) {
          return $options.onChoosePublish('assets');
        })
      }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("img", {
        class: "publish-icon-img",
        src: $data.zichanIcon,
        alt: ""
      }, null, 8, _hoisted_41)]), _cache[23] || (_cache[23] = _createElementVNode("div", {
        class: "publish-text"
      }, [_createElementVNode("div", {
        class: "publish-title"
      }, "从资产中发表"), _createElementVNode("div", {
        class: "publish-desc"
      }, "发布你创作过的作品吧")], -1))]), _createVNode(_component_van_icon, {
        class: "publish-arrow",
        name: "arrow"
      })]), _createElementVNode("div", {
        class: "publish-item",
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return $options.onChoosePublish('album');
        })
      }, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("img", {
        class: "publish-icon-img",
        src: $data.xiangceIcon,
        alt: ""
      }, null, 8, _hoisted_44)]), _cache[24] || (_cache[24] = _createElementVNode("div", {
        class: "publish-text"
      }, [_createElementVNode("div", {
        class: "publish-title"
      }, "从相册中发表"), _createElementVNode("div", {
        class: "publish-desc"
      }, "相册素材，即刻分享")], -1))]), _createVNode(_component_van_icon, {
        class: "publish-arrow",
        name: "arrow"
      })]), _createElementVNode("div", {
        class: "publish-close",
        onClick: _cache[12] || (_cache[12] = function ($event) {
          return $data.publishSheetShow = false;
        })
      }, [_createVNode(_component_van_icon, {
        name: "cross"
      })])])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_CreatorContestKefuPopup, {
    show: $data.kefuPopupShow,
    "onUpdate:show": _cache[14] || (_cache[14] = function ($event) {
      return $data.kefuPopupShow = $event;
    })
  }, null, 8, ["show"]), _createVNode(_component_CirclePostOpenAppConfirm, {
    show: _ctx.showAppLeaveConfirm,
    "onUpdate:show": _cache[15] || (_cache[15] = function ($event) {
      return _ctx.showAppLeaveConfirm = $event;
    }),
    onConfirm: _ctx.confirmOpenActivityApp
  }, null, 8, ["show", "onConfirm"])], 4);
}